
export default {
    getAppName(state) {
        return state.appName;
    },
    getMenuState(state) {
        return state.menu.drawer
    },
    getLoader(state) {
        return state.loader
    },
    getModules(state) {
        return state.modules
    },
    getUserData(state) {
        return state.userData
    },
    getUserPermissions(state) {
        return state.userPermissions
    },

}